import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import styles from './icon-base.module.scss.js';

/**
 * @component IconBase
 * @package Icons
 * @props IconProps
 */
const IconBase = ({ ariaHidden = false, 'aria-label': arialabel, ariaLabel, size, surface = 'lightPrimary', id, tabIndex, iconName, viewBox, svgContent, color, title, }) => {
    const iconStyles = [styles.icon];
    const newAriaLabel = title || ariaLabel || arialabel || `${iconName} icon`;
    const getIconSize = () => {
        switch (size) {
            case 'xlarge':
                return 28;
            case 'large':
                return 24;
            case 'small':
                return 16;
            case 'medium':
                return 20;
            default:
                return size || 20;
        }
    };
    const newSize = getIconSize();
    return (jsxs("svg", { className: iconStyles.join(' '), style: {
            width: newSize,
            height: newSize,
            maxHeight: newSize,
            maxWidth: newSize,
            color,
        }, id: id, role: "img", "aria-hidden": ariaHidden, "aria-label": newAriaLabel, tabIndex: tabIndex, viewBox: viewBox, fill: color || `var(--vds-color-element-primary-on${surface.toLowerCase()})`, children: [!ariaHidden && jsx("title", { children: newAriaLabel }), svgContent] }));
};

export { IconBase, IconBase as default };
